export default __webpack_public_path__ + "static/media/background.a21bc295.jpg";